export const bFiltersStateArraySelector = (state) => state.appFilterAndSort.bFiltersStateArray;
export const nFiltersStateArraySelector = (state) => state.appFilterAndSort.nFiltersStateArray;
export const petFriendlySelectedSelector = (state) => state.appFilterAndSort.petFriendlySelected;
export const getRangeSliderMinValueSelector = (state) => state.appFilterAndSort.rangeSliderMin;
export const getRangeSliderMaxValueSelector = (state) => state.appFilterAndSort.rangeSliderMax;
export const resultsAppliedSortSelector = (state) => state.appFilterAndSort.resultsAppliedSort;
